// extracted by mini-css-extract-plugin
export default {"navList":"HomePage_navList__6g-oB","link":"HomePage_link__-d+Of","navItem":"HomePage_navItem__RW1hL","pictureBox":"HomePage_pictureBox__Cz1Vy","picture":"HomePage_picture__qM40q"};